import { LocalStorageSchema } from "./types";

const localStorageHandler = {
    get: (target: LocalStorageSchema, name: string) => {
        const res = window.localStorage.getItem(name);
        return res === null ? target[name] : JSON.parse(res);
    },
    set: (_target: LocalStorageSchema, name: string, value: any, _receiver: any) => {
        window.localStorage.setItem(name, JSON.stringify(value));
        return true;
    },
};

export const heimdallLocalStorage = new Proxy<LocalStorageSchema>(new LocalStorageSchema(), localStorageHandler);

export function sleep(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

export const getLocalePrimaryTag = (locale: string): string => {
    if (locale == null) return undefined;
    return locale.replace("_", "-").split("-")[0];
};
